import React from 'react';

export function QuickPrivacyModal() {
    return (
            <div className="ui longer modal" id={"privacyModal"}>
                <i className={"close icon"}></i>
                <div className={"ui clearing segment"}>
                    <h3 className={"ui header"}> Privacy Policy &nbsp; &nbsp;
                        <span className={"tiny"}> <a href={"/privacy"}> <i className={"external alternate icon"}></i>  </a> </span>
                    </h3>
                </div>
                <div className={"scrolling content"}> <QuickPrivacyContent/> </div>
            </div>
    )
}

function QuickPrivacyContent() {
    return (
        <div>
            <div className="ui celled list">
                <div className="item">
                    <i className={"eye slash icon"}></i>
                        <div className="content">
                            <div className="header">Account Credentials</div>
                            We do not store or collect any passwords, including any password or phone number you use to login to your Amazon account.
                        </div>
                </div>
                <div className="item">
                    <i className="eye slash icon"></i>
                        <div className="content">
                            <div className="header">Banking Credentials</div>
                            We do not store any of your banking credentials. We, rely on Plaid (www.plaid.com) to receive, collect, and store the bank credentials that you provide.
                        </div>
                </div>
                <div className="item">
                    <i className="eye slash icon"></i>
                    <div className="content">
                        <div className="header">Data Sharing</div>
                        We do not share your data with any third-party services or organizations.
                    </div>
                </div>
                <div className="item">
                    <i className="eye slash icon"></i>
                    <div className="content">
                        <div className="header">Personally Identifable Information </div>
                        We do not store, receive, or collect any sensitive or personally identifiable information such as "phone numbers", "home address", or "social security numbers."
                    </div>
                </div>

                <div className="item">
                    <i className="eye icon"></i>
                    <div className="content">
                        <div className="header">Account Data</div>
                        We receive and store only a minimal set of data from your financial institutions. We need to do so for the purpose of providing you with our core services.
                    </div>
                </div>

                <div className="item">
                    <i className="eye icon"></i>
                    <div className="content">
                        <div className="header">Name and email</div>
                        We store your name and email address for identifying your profile in our application. Your email address also lets us contact you in case of un-forseen circumstances such as data breach, critical updates, and/or any account issues.
                    </div>
                </div>

            </div>
        </div>
    )
}